import React from 'react';

const ContactDealer = ({ filled, color = 'currentColor' }: { filled?: boolean; color?: string }) => {
  if (filled) {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.2108 1C21.0792 1 21.7923 1.66487 21.8689 2.51334L21.8757 2.66487V16.6005C21.8757 17.4689 21.2108 18.182 20.3624 18.2586L20.2108 18.2654H18.3471L18.1719 17.2849C17.7876 15.1438 16.2061 13.4746 14.192 12.9167C14.868 11.9996 15.2678 10.865 15.2687 9.63689C15.271 6.66798 12.9364 4.22678 9.98051 4.08918L9.7553 4.08345L9.5428 4.08618L9.54329 2.66487C9.54329 1.79647 10.2082 1.08336 11.0566 1.0068L11.2082 1H20.2108ZM6.16195 13.9543L6.24079 13.9524C7.19111 14.7193 8.39916 15.1793 9.71494 15.1823C11.0237 15.1823 12.2262 14.7304 13.1752 13.9744C14.9901 14.1694 16.5008 15.4966 16.9151 17.2934L16.958 17.5028L17.523 20.4618C17.7671 21.6311 15.1733 23 9.71494 23C4.25661 23 1.24023 21.7564 1.51758 20.4618L1.52723 20.3681L2.12857 17.5028C2.48501 15.5169 4.16558 14.0529 6.16195 13.9543ZM15.7095 5.86616H19.8162V7.233H15.7095V5.86616ZM9.72569 5.31634L9.92316 5.32108C12.2139 5.42772 14.0372 7.31957 14.0355 9.63595C14.0337 12.0185 12.1017 13.949 9.71774 13.949C7.33308 13.9436 5.40281 12.0089 5.40281 9.62285C5.40808 7.30647 7.23712 5.42017 9.52821 5.32048L9.72569 5.31634ZM15.7095 3.26094H19.8162V4.62778H15.7095V3.26094Z"
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.89578 2.45C9.89578 1.64919 10.545 1 11.3458 1H21.8858C22.6866 1 23.3358 1.64919 23.3358 2.45V18.08C23.3358 18.8808 22.6866 19.53 21.8858 19.53H18.4658L18.7658 21.05C18.8419 21.4325 18.7476 21.8292 18.5075 22.1365C18.2674 22.4438 17.9053 22.6313 17.5158 22.65C14.9858 22.77 12.4358 22.83 9.89578 22.83C7.35578 22.83 4.80578 22.77 2.27578 22.65C1.88623 22.6313 1.52416 22.4438 1.28406 22.1365C1.04396 21.8292 0.949662 21.4325 1.02578 21.05L1.79578 17.24C2.00911 16.1602 2.76562 15.2675 3.79578 14.88L5.67578 14.17L6.16578 15.38L4.26578 16.08C3.66553 16.3098 3.22425 16.8302 3.09578 17.46L2.33578 21.31C3.07578 21.39 5.17578 21.46 5.92578 21.46C8.55578 21.52 11.1958 21.52 13.8258 21.46L17.5058 21.37L16.7458 17.5C16.6208 16.8685 16.1783 16.3466 15.5758 16.12L13.6958 15.42L14.1658 14.17L15.9658 14.84C17.0006 15.2209 17.7597 16.1167 17.9658 17.2L18.1658 18.2H21.8858C21.9481 18.1948 21.996 18.1426 21.9958 18.08V2.45C21.9958 2.38925 21.9465 2.34 21.8858 2.34H11.3458C11.3149 2.33718 11.2843 2.34752 11.2615 2.36846C11.2386 2.3894 11.2257 2.41901 11.2258 2.45V6.17C13.4592 6.87915 14.7688 9.18961 14.23 11.4701C13.6911 13.7506 11.4859 15.2306 9.17129 14.8651C6.85668 14.4996 5.21474 12.4122 5.40476 10.0766C5.59477 7.74108 7.55254 5.94652 9.89578 5.96V2.45ZM9.88914 13.41C11.5778 13.4137 12.9503 12.0487 12.9558 10.36C12.9558 8.66838 11.5874 7.29551 9.89578 7.29C8.20709 7.29001 6.83763 8.65799 6.8358 10.3467C6.83397 12.0354 8.20045 13.4063 9.88914 13.41Z"
        fill={color}
      />
      <path d="M15.6658 7.58H20.1458V8.91H15.6658V7.58Z" fill={color} />
      <path d="M20.1458 4.54H15.6658V5.87H20.1458V4.54Z" fill={color} />
    </svg>
  );
};

export default ContactDealer;
